import React from "react";
import InContentAskAiFormFields from "./InContentAskAiFormFields";
import InContentDiscussionFormFields from "./InContentDiscussionQuestionFormFields";
import { AI_TOOL_NAMES } from "../../constants";

const InContentToolFormFields = ({ toolName, ...props }) => {
  switch (toolName) {
    case AI_TOOL_NAMES.ASK_AI:
      return (
        <InContentAskAiFormFields toolName={AI_TOOL_NAMES.ASK_AI} {...props} />
      );
    case AI_TOOL_NAMES.DISCUSSION_QUESTIONS:
      return (
        <InContentDiscussionFormFields
          toolName={AI_TOOL_NAMES.DISCUSSION_QUESTIONS}
          {...props}
        />
      );
    default:
      return null;
  }
};

export default InContentToolFormFields;
